import ThirdStatistics from './statictics'
import Core from '_abstracts/core'

Core.Tasks.add(['content'], () => {
    new ThirdStatistics()
})
